<template>
  <section class="registrationPrompt__Inner">
    <h1 class="registrationPrompt__Title">{{ $store.getters.getStringTranslation('forgotPass') }}</h1>
    <p class="registrationPrompt__Lead">{{ $store.getters.getStringTranslation('enterMailFix') }}</p>

    <form @submit.prevent="reset()">
      <p>
        <label class="formLabel" for="email">{{ $store.getters.getStringTranslation('email') }}</label>
        <input class="formInput" type="email" id="email" v-model="email" />
      </p>

      <p v-if="success.text !== ''" class="message--Success" v-html="success.text"></p>
      <p v-if="error.text !== ''" class="message--Important" v-html="error.text"></p>

      <div class="registrationPrompt__Submit">
        <p>
          <router-link :to="{ name: 'Login' }"
            >&lt; {{ $store.getters.getStringTranslation('backToLogin') }}</router-link
          >
        </p>
        <p>
          <button class="button--Registration" type="submit" :disabled="success.status === true">
            {{ $store.getters.getStringTranslation('requestChange') }}
          </button>
        </p>
      </div>
    </form>
  </section>
</template>

<script>
import HTTP from '@/http-common.js'

export default {
  name: 'Reset',
  data() {
    return {
      email: '',
      error: {
        text: '',
      },
      success: {
        text: '',
        status: false,
      },
    }
  },
  methods: {
    reset() {
      this.loading = true
      HTTP.post('request_password_reset', { email: this.email })
        .then((response) => {
          this.loading = false
          this.error.text = ''
          if (response.data === 'ok') {
            this.success.text = 'All done. Please check your e-mail while we redirect you to login.'
            this.success.status = true
            setTimeout(() => {
              this.$router.push({ name: 'Login' })
            }, 3000)
          }
        })
        .catch((e) => {
          this.loading = false
          this.success.text = ''
          if (e.response.status === 422) {
            this.error.text = "E-mail not found. Are you sure it's the right one?"
          }
        })
    },
  },
}
</script>
